import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}inspections/`;

const fetchInspections = (page, searchTerm = '', orderInfo, forWorker, siteId = null) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}?page=${page}&for_worker=${forWorker}&term=${searchTerm}&site_id=${siteId}`;
  if (orderInfo) {
    endpointURL = `${apiURL}?page=${page}&for_worker=${forWorker}&term=${searchTerm}&order=${orderInfo.order}&direction=${orderInfo.direction}&site_id=${siteId}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchInspection = (id, withDeleted) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}?with_deleted=${withDeleted}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createInspection = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateInspection = params => new Promise(((resolve, reject) => {
  if (params == null || params === undefined) {
    return;
  }
  const endpointURL = `${apiURL}${params.id}/update`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateInspectionStatementResult = (params, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${params.id}/update_result/${id}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateInspectionStatementMemo = (params, inspectionStatementId, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${params.id}/inspection_statement/${inspectionStatementId}/update_memo/${id}`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const finalizeInspection = (id, inspectionsStatementsMemos, participantIds) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/finalize`;
  fetchData(endpointURL, 'post', { inspections_statements_memos: inspectionsStatementsMemos, participant_ids: participantIds }, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteInspection = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const removeApproval = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${id}/remove_approval`;
  fetchData(endpointURL, 'post', {}, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  fetchInspections,
  fetchInspection,
  updateInspection,
  createInspection,
  deleteInspection,
  updateInspectionStatementResult,
  updateInspectionStatementMemo,
  finalizeInspection,
  removeApproval,
};



// WEBPACK FOOTER //
// ./src/api/inspections.js